import { HttpService } from "../http/HttpService";
import { AdminPersonalTokenListResponse, MintPersonalTokenRequest, MintPersonalTokenResponse } from "../http/protocol";

/** Every endpoint resolves the acting admin from the session, so no call here carries an admin id. */
const ENTITY_PATH = "/admin-personal-token";

export class AdminPersonalTokenService {
  constructor(private http: HttpService) {}

  list(): Promise<AdminPersonalTokenListResponse> {
    return this.http.get(ENTITY_PATH);
  }

  /** Answers with the token value, which is readable here and nowhere else. */
  mint(request: MintPersonalTokenRequest): Promise<MintPersonalTokenResponse> {
    return this.http.post(ENTITY_PATH, request);
  }

  revoke(tokenId: number): Promise<{}> {
    return this.http.delete(`${ENTITY_PATH}/${tokenId}`);
  }

  /** Mails a step-up code to the caller. Only an admin whose second factor is mail needs one. */
  sendStepUpOtp(): Promise<void> {
    return this.http.post(`${ENTITY_PATH}/step-up/send-otp`, {});
  }
}
